import styled from 'styled-components';

const mobileScreenWidth = '768px';

export const AppWrapper = styled.div`
  padding: 98px 24px;
  display: flex;
  justify-content: center;

  > :first-child {
    width: 418px;
  }
`;

const helpPanelWidthLarge = '434px';
const helpPanelWidthSmall = '100%';

const show = `visibility: visible;`;
const hide = `
  transform: translateX(${helpPanelWidthLarge}); 

  @media (max-width: ${mobileScreenWidth}) {
    transform: translateX(${helpPanelWidthSmall}); 
  }

  visibility: hidden;
`;

export const SidePanelWrapper = styled.div`
  position: fixed;
  width: ${helpPanelWidthLarge};
  min-height: 100vh;
  top: 0;
  right: 0;
  z-index: 15;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  transition-duration: 600ms;
  -webkit-transition: 600ms;

  @media (max-width: ${mobileScreenWidth}) {
    width: ${helpPanelWidthSmall};
  }

  ${props => (props.show ? show : hide)};
`;

export const WithAdWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;

  @media (min-width: 1024px) {
    flex-direction: row;
    width: 100vw;
  }
`;
